var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "office-supplies-table" }, [
    _vm.rowLayout
      ? _c(
          "div",
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  size: "medium",
                  "header-cell-style": {
                    background: "#f5f7fa",
                    padding: "3px 0",
                  },
                  border: true,
                  data: _vm._value,
                  "summary-method": _vm.getSummaries,
                  "show-summary": "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    fixed: "",
                    type: "index",
                    label: "序号",
                    width: "55",
                  },
                }),
                _c(
                  "el-table-column",
                  {
                    attrs: {
                      prop: "goodsName",
                      label: "物品名称",
                      "min-width": "160",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "input-container" },
                                [
                                  !_vm.readerMode
                                    ? _c("el-input", {
                                        class: {
                                          "error-border": _vm.hasError(
                                            scope.$index,
                                            "goodsName"
                                          ),
                                        },
                                        attrs: {
                                          size: "small",
                                          placeholder: "请输入",
                                          maxlength: "24",
                                          "show-word-limit": "",
                                        },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.validateField(
                                              scope.$index,
                                              "goodsName",
                                              _vm._value[scope.$index].goodsName
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm._value[scope.$index].goodsName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm._value[scope.$index],
                                              "goodsName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "_value[scope.$index].goodsName",
                                        },
                                      })
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._value[scope.$index]
                                              .goodsName || "-"
                                          )
                                        ),
                                      ]),
                                ],
                                1
                              ),
                              _vm.hasError(scope.$index, "goodsName")
                                ? _c("div", { staticClass: "error-message" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getErrorMessage(
                                            scope.$index,
                                            "goodsName"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      551617602
                    ),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c("span", { staticClass: "required-field" }, [
                        _vm._v("物品名称"),
                      ]),
                    ]),
                  ],
                  2
                ),
                _c("el-table-column", {
                  attrs: {
                    prop: "specification",
                    label: "规格",
                    "min-width": "140",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "input-container" },
                              [
                                !_vm.readerMode
                                  ? _c("el-input", {
                                      attrs: {
                                        size: "small",
                                        placeholder: "请输入",
                                        maxlength: "24",
                                        "show-word-limit": "",
                                      },
                                      model: {
                                        value:
                                          _vm._value[scope.$index]
                                            .specification,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm._value[scope.$index],
                                            "specification",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "_value[scope.$index].specification",
                                      },
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._value[scope.$index]
                                            .specification || "-"
                                        )
                                      ),
                                    ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3799138880
                  ),
                }),
                _c(
                  "el-table-column",
                  {
                    attrs: {
                      prop: "unitOfMeasure",
                      label: "单位",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "input-container" },
                                [
                                  !_vm.readerMode
                                    ? _c("el-input", {
                                        class: {
                                          "error-border": _vm.hasError(
                                            scope.$index,
                                            "unitOfMeasure"
                                          ),
                                        },
                                        attrs: {
                                          size: "small",
                                          placeholder: "请输入",
                                          maxlength: "6",
                                          "show-word-limit": "",
                                        },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.validateField(
                                              scope.$index,
                                              "unitOfMeasure",
                                              _vm._value[scope.$index]
                                                .unitOfMeasure
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm._value[scope.$index]
                                              .unitOfMeasure,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm._value[scope.$index],
                                              "unitOfMeasure",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "_value[scope.$index].unitOfMeasure",
                                        },
                                      })
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._value[scope.$index]
                                              .unitOfMeasure || "-"
                                          )
                                        ),
                                      ]),
                                ],
                                1
                              ),
                              _vm.hasError(scope.$index, "unitOfMeasure")
                                ? _c("div", { staticClass: "error-message" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getErrorMessage(
                                            scope.$index,
                                            "unitOfMeasure"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1354077586
                    ),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c("span", { staticClass: "required-field" }, [
                        _vm._v("单位"),
                      ]),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: {
                      prop: "quantity",
                      label: "采购数量",
                      "min-width": "110",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "input-container" },
                                [
                                  !_vm.readerMode
                                    ? _c("el-input", {
                                        class: {
                                          "error-border": _vm.hasError(
                                            scope.$index,
                                            "quantity"
                                          ),
                                        },
                                        attrs: {
                                          size: "small",
                                          maxlength: "16",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.handleQuantityInput(
                                              scope.$index,
                                              $event
                                            )
                                          },
                                          blur: function ($event) {
                                            return _vm.validateField(
                                              scope.$index,
                                              "quantity",
                                              _vm._value[scope.$index].quantity
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm._value[scope.$index].quantity,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm._value[scope.$index],
                                              "quantity",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "_value[scope.$index].quantity",
                                        },
                                      })
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._value[scope.$index].quantity ||
                                              0
                                          )
                                        ),
                                      ]),
                                ],
                                1
                              ),
                              _vm.hasError(scope.$index, "quantity")
                                ? _c("div", { staticClass: "error-message" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getErrorMessage(
                                            scope.$index,
                                            "quantity"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      568888883
                    ),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c("span", { staticClass: "required-field" }, [
                        _vm._v("采购数量"),
                      ]),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: {
                      prop: "estimatedUnitPrice",
                      label: "估价",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "input-container" },
                                [
                                  !_vm.readerMode
                                    ? _c("el-input", {
                                        class: {
                                          "error-border": _vm.hasError(
                                            scope.$index,
                                            "estimatedUnitPrice"
                                          ),
                                        },
                                        attrs: {
                                          size: "small",
                                          maxlength: "16",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.handlePriceInput(
                                              scope.$index,
                                              $event
                                            )
                                          },
                                          blur: function ($event) {
                                            return _vm.validateField(
                                              scope.$index,
                                              "estimatedUnitPrice",
                                              _vm._value[scope.$index]
                                                .estimatedUnitPrice
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm._value[scope.$index]
                                              .estimatedUnitPrice,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm._value[scope.$index],
                                              "estimatedUnitPrice",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "_value[scope.$index].estimatedUnitPrice",
                                        },
                                      })
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatMoney(
                                              _vm._value[scope.$index]
                                                .estimatedUnitPrice
                                            )
                                          )
                                        ),
                                      ]),
                                ],
                                1
                              ),
                              _vm.hasError(scope.$index, "estimatedUnitPrice")
                                ? _c("div", { staticClass: "error-message" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getErrorMessage(
                                            scope.$index,
                                            "estimatedUnitPrice"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2813591781
                    ),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c("span", { staticClass: "required-field" }, [
                        _vm._v("估价"),
                      ]),
                    ]),
                  ],
                  2
                ),
                _c("el-table-column", {
                  staticClass: "last-column",
                  attrs: {
                    prop: "requiredDeliveryTime",
                    label: "需求到货时间",
                    "min-width": "230",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "input-container" },
                              [
                                !_vm.readerMode
                                  ? _c("el-date-picker", {
                                      staticClass: "custom-date-picker",
                                      attrs: {
                                        type: "date",
                                        size: "small",
                                        "value-format": "yyyy-MM-dd",
                                        placeholder: "选择日期",
                                      },
                                      model: {
                                        value:
                                          _vm._value[scope.$index]
                                            .requiredDeliveryTime,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm._value[scope.$index],
                                            "requiredDeliveryTime",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "_value[scope.$index].requiredDeliveryTime",
                                      },
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._value[scope.$index]
                                            .requiredDeliveryTime || "-"
                                        )
                                      ),
                                    ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    642181484
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "imageSpecialNotes",
                    label: "图片特殊备注",
                    "min-width": "160",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "input-container" },
                              [
                                !_vm.readerMode
                                  ? _c("el-input", {
                                      attrs: {
                                        size: "small",
                                        placeholder: "备注",
                                        maxlength: "64",
                                        "show-word-limit": "",
                                      },
                                      model: {
                                        value:
                                          _vm._value[scope.$index]
                                            .imageSpecialNotes,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm._value[scope.$index],
                                            "imageSpecialNotes",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "_value[scope.$index].imageSpecialNotes",
                                      },
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._value[scope.$index]
                                            .imageSpecialNotes || "-"
                                        )
                                      ),
                                    ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1134594794
                  ),
                }),
                !_vm.readerMode
                  ? _c("el-table-column", {
                      attrs: {
                        fixed: "right",
                        "min-width": "120",
                        label: "操作",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "center",
                                      gap: "8px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.copyData(
                                              scope.$index,
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("复制")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.delRow(
                                              scope.$index,
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        343155873
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
            !_vm.readerMode
              ? _c(
                  "el-button",
                  {
                    attrs: {
                      type: "text",
                      size: "small",
                      icon: "el-icon-plus",
                    },
                    on: { click: _vm.addRow },
                  },
                  [_vm._v("添加物资")]
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }